const ProjectSVG = ({ color }) => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.75 6.125C2.75 4.26104 4.26104 2.75 6.125 2.75H9.83574C10.3467 2.75 10.8424 2.92388 11.2413 3.24305L12.513 4.26043C13.1115 4.73918 13.855 5 14.6214 5H20.75C23 5 24.125 7.25 24.125 9.5H8.40021C7.72167 9.5 7.12762 9.95551 6.95157 10.6108L3.39295 23.857C2.98853 23.3004 2.75 22.6156 2.75 21.875V6.125ZM25.9375 11.75H10.625C9.95833 11.75 9.37167 12.19 9.185 12.83L5.8425 24.29C5.7025 24.77 6.0625 25.25 6.5625 25.25H21.875C22.5417 25.25 23.1283 24.81 23.315 24.17L26.6575 12.71C26.7975 12.23 26.4375 11.75 25.9375 11.75Z" fill={color}/>
        </svg>

    );
}

export default ProjectSVG;